import { Injectable } from '@angular/core';

const ACCESS_TOKEN_KEY  = 'gx_access_token';
const REFRESH_TOKEN_KEY = 'gx_refresh_token';
const THEME_KEY         = 'gx_theme';

@Injectable({ providedIn: 'root' })
export class StorageService {
  // --- Tokens ---
  getAccessToken(): string | null {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  }

  setAccessToken(token: string): void {
    localStorage.setItem(ACCESS_TOKEN_KEY, token);
  }

  getRefreshToken(): string | null {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  }

  setRefreshToken(token: string): void {
    localStorage.setItem(REFRESH_TOKEN_KEY, token);
  }

  clearTokens(): void {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
  }

  // --- Theme ---
  getTheme(): 'light' | 'dark' {
    const stored = localStorage.getItem(THEME_KEY);
    if (stored === 'dark' || stored === 'light') return stored;
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }

  setTheme(theme: 'light' | 'dark'): void {
    localStorage.setItem(THEME_KEY, theme);
  }
}
